import React, {useContext, useEffect, useState} from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import SellIcon from '@mui/icons-material/Sell';
import FavoriteIcon from '@mui/icons-material/Favorite';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import {useNavigate} from "react-router-dom";
import {UserContext} from "../../hooks/userContext";
import {Badge} from "@mui/material";
import {useLazyQueryOrders} from "../../queries/order/hooks/useLazyQueryOrders";

interface IMainListItemsProps {
  isAdmin: boolean;
}

const MainListItems:React.FunctionComponent<IMainListItemsProps> = ({
  isAdmin
}) => {
  const { id }: any = useContext(UserContext);
  const navigate = useNavigate();
  const [count, setCount] = useState<number>(0);

  const [getOrders, { data }] = useLazyQueryOrders({
    variables: {
      where: {
        AND: [
          { sellerUserId: {equals: +id} },
          { isConfirmed: {equals: false }},
          { status: {equals: 1}}
        ]
      },
    },
    fetchPolicy: 'no-cache'
  });

  const getCount = (items: any) => {
    if (!items) {
      return 0;
    }

    let newData: any = [];

    items.forEach((item: any) => {
      const foundOrderIndex = newData.findIndex((dataItem: any) => dataItem.orderNumber === item.orderNumber);

      if (foundOrderIndex === -1) {
        newData.push(item);
      } else {
        newData[foundOrderIndex] = item;
      }
    });

    return newData.length;
  }

  useEffect(() => {
    if (isAdmin) return;

    getOrders();
    const interval = setInterval(() => {
      getOrders();
    }, 5000);

    return () => clearInterval(interval);
  }, [getOrders, isAdmin]);

  useEffect(() => {
    if (data?.findManyOrder) {
      setCount(getCount(data?.findManyOrder));
    }
  }, [data?.findManyOrder]);

  if (isAdmin) {
    return <React.Fragment>
      <ListItemButton onClick={() => navigate('/pharmacies')}>
        <ListItemIcon>
          <LocalPharmacyIcon />
        </ListItemIcon>
        <ListItemText primary="Pharmacies" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/postings')}>
        <ListItemIcon>
          <SellIcon />
        </ListItemIcon>
        <ListItemText primary="Postings" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/sales')}>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="Sales" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/orders')}>
        <ListItemIcon>
          <FactCheckIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItemButton>
    </React.Fragment>
  }

  return (
    <React.Fragment>
      <ListItemButton onClick={() => navigate('/')}>
        <ListItemIcon>
          <StorefrontRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Buy" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/sell')}>
        <ListItemIcon>
          <SellIcon />
        </ListItemIcon>
        <ListItemText primary="Sell" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/wishlist')}>
        <ListItemIcon>
          <FavoriteIcon />
        </ListItemIcon>
        <ListItemText primary="Wishlist" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/buy-history')}>
        <ListItemIcon>
          <FactCheckIcon />
        </ListItemIcon>
        <ListItemText primary="Buy History" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/open-orders')}>
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="Open Orders" />
        {count > 0 && (
          <Badge badgeContent={count} color="success" sx={{left: '-35%'}} />
        )}
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/sell-history')}>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="Sell History" />
      </ListItemButton>
      <ListItemButton onClick={() => navigate('/dashboard')}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
    </React.Fragment>
  )
};

export default MainListItems;